import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Logo from '../../assets/logo/LogoPittogrammaeScritta.svg';
import FireIcon from '../../assets/icone/header/iconaFuocoOut.svg';
import TrainIcon from '../../assets/icone/header/iconaTreniOut.svg';
import FlightIcon from '../../assets/icone/header/iconaAereiOut.svg';
import RoomIcon from '../../assets/icone/header/iconaAlloggiOut.svg';
import FireColored from '../../assets/icone/header/iconOccasionsColored.svg'
import FlightColored from '../../assets/icone/header/iconAirplaneColored.svg'
import TrainColored from '../../assets/icone/header/iconTrainColored.svg'
import RoomColored from '../../assets/icone/header/iconRoomColored.svg'
import SellTicketButton from '../../components/button/SellTicketButton';
import LikeButton from '../../components/button/LikeButton';
import ProfileButton from '../../components/button/ProfileButton';
import LanguageSwitcher from '../../utils/LenguageSwitcher';

const HeaderDesktop = () => {
    const { t } = useTranslation();
    const [clicked, setClicked] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleButtonClick = (newCategory) => {
        setClicked(newCategory);

        switch (newCategory) {
            case 'fire':
                navigate('/');
                break;
            case 'train':
                navigate('/trainTicket');
                break;
            case 'flight':
                navigate('/flightTicket');
                break;
            case 'room':
                navigate('/roomTicket');
                break;
            default:
                break;
        }
    };

    const handleProfileOrLikeClick = () => {
        setClicked('');
    };

    const getCategoryIcon = (category) => {
        const iconStyle = 'w-8 h-8'; // Dimensione fissa per tutte le icone
        const isActive = clicked === category;
    
        let iconSrc;
        switch (category) {
            case 'fire':
                iconSrc = isActive ? FireColored : FireIcon;
                break;
            case 'train':
                iconSrc = isActive ? TrainColored : TrainIcon;
                break;
            case 'room':
                iconSrc = isActive ? RoomColored : RoomIcon;
                break;
            case 'flight':
                iconSrc = isActive ? FlightColored : FlightIcon;
                break;
            default:
                iconSrc = null;
        }
    
        return (
            <div className={iconStyle}>
                <img src={iconSrc} alt={`${category} Icon`} className="w-full h-full" />
            </div>
        );
    };
    

    useEffect(() => {
        const path = location.pathname;
        if (path === '/') {
            setClicked('fire');
        } else if (path.includes('experience')) {
            setClicked('fire');
        } else if (path.includes('train')) {
            setClicked('train');
        } else if (path.includes('flight')) {
            setClicked('flight');
        } else if (path.includes('room')) {
            setClicked('room');
        }
    }, [location]);

    return (
        <header className="w-full flex items-center justify-between md:px-4 lg:px-14 md:mx-10 bg-white border-b border-gray-300 py-4 mb-10 md:mb-20 fixed top-0 z-40">
            <Link to="/" className="block" aria-label="Save Your Travel - Home">
                <img src={Logo} alt="Save Your Travel Logo" className="lg:h-12 md:h-8  " />
            </Link>

            <nav aria-label="Navigazione principale categorie" role="navigation">
                <ul className="flex items-center justify-center space-x-4 lg:w-4/5 md:w-2/5 pt-1 list-none m-0 p-0">
                    {['fire','room','train','flight'].map((item) => (
                        <li key={item}>
                            <button
                                onClick={() => handleButtonClick(item)}
                                aria-current={clicked === item ? 'page' : undefined}
                                className={`text-sm md:text-base lg:text-xl font-heading uppercase px-2 lg:px-6 md:px-4 py-1 md:py-2 font-semibold flex items-center justify-center ${clicked === item ? 'text-black' : 'text-gray-500'} ${clicked === item ? 'animate-press' : ''} space-x-2`}
                            >
                                {getCategoryIcon(item)}
                                <span className="adjusted-text">{t(`search.${item}`)}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            <div className="flex items-center justify-center space-x-3">
                <SellTicketButton />
                <LikeButton onClick={handleProfileOrLikeClick} />
                <ProfileButton onClickProfile={handleProfileOrLikeClick} />
                <LanguageSwitcher />
            </div>
        </header>
    );
};

export default HeaderDesktop;
